<template>
  <div>
    <div :id="captchaDivId"></div>
  </div>
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data: () => ({
    idKey: ''
  }),
  computed: {
    captchaDivId() {
      return `captcha-${this.idKey}`
    },
    captchaSuccessCallbackFnName() {
      return `onCaptchaSuccess${this.idKey}`
    }
  },
  created() {
    this.idKey = Math.random()
      .toString(36)
      .slice(2)
  },
  mounted() {
    window[this.captchaSuccessCallbackFnName] = this.onCaptchaSuccess
    window.grecaptcha.render(this.captchaDivId, {
      sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY_V2,
      callback: this.captchaSuccessCallbackFnName,
      action: this.action
    })
  },

  methods: {
    onCaptchaSuccess(args) {
      this.$emit('input', args)
    }
  }
}
</script>
